<template>
  <div class="service-lists">
    <div>
      <!--searchForm : {{searchForm}}-->
    </div>
    <div class="search-box">
      <dropdown-box-type-1
        box-title="CITY"
        title="Choose your city"
        :data="city"
        v-model="searchCity"
      />
      <dropdown-box-type-1
        box-title="WHAT FOR"
        title="Type of event"
        :data="speciality"
        v-model="searchSpeciality"
      />
      <dropdown-calendar-type1 v-model="searchDate" />
      <dropdown-time-type-5 v-model="searchTime" ref="timeList" />
    </div>
    <div class="search-box-1">
      <range-bar
        class="space"
        :priceRange="rangePriceStatic"
        v-on:model="v => _filterPriceRange(v)"
      ></range-bar>
      <sort-by class="space" v-on:model="v => _filterSort(v)"></sort-by>
      <language class="space" v-on:model="v => _filterLanguage(v)"></language>
      <input
        type="text"
        class="search"
        placeholder="SEARCH"
        v-model="searchName"
        @change="_filterName"
      />
      <div class="search-reset" @click="_reset">
        <i class="material-icons">clear</i>reset
      </div>
    </div>
    <transition-group name="list" mode="out-in" tag="div" class="lists">
      <div
        class="item"
        v-for="(item, index) in serviceLists"
        v-bind:key="index + 'service'"
        v-show="item.filter"
        @click="detail(item.id)"
      >
        <photo-box :data="item"></photo-box>
      </div>
    </transition-group>
  </div>
</template>

<script>
import DropdownCalendarType1 from '../common/DropdownCalendarType1.vue'
import * as types from '../../store/mutation-types'
import PhotoBox from '../common/PhotoBox'
import RangeBar from '../common/RangeBar'
import SortBy from '../common/SortBy'
import Language from '../common/Language'
import { getCities, getSpecialties } from '../../api/common_code'
import { defaultStore } from '../../library/firebase'
import DropdownBoxType1 from '../common/DropdownBoxType1'
import DropdownTimeType5 from '../common/DropdownTimeType5'
import moment from 'moment'

export default {
  name: 'service-lists',
  components: {
    Language,
    SortBy,
    RangeBar,
    PhotoBox,
    DropdownBoxType1,
    DropdownCalendarType1,
    DropdownTimeType5
  },
  data() {
    return {
      searchCity: this.$route.query.city || '',
      searchName: '',
      searchSpeciality: this.$route.query.speciality || '',
      searchDate: '',
      searchTime: {
        startTime: '',
        endTime: ''
      },
      searchForm: {
        city: '',
        speciality: '',
        date: '',
        time: '',
        name: '',
        priceRange: '',
        sort: '',
        language: '',
        offset: '',
        limit: ''
      },
      city: {},
      speciality: {},
      serviceLists: [],
      loadingComplete: false,
      rangePriceStatic: []
    }
  },
  created() {
    this.getDefaultData()
  },
  methods: {
    _reset() {
      this.serviceLists.map(v => {
        v.filter = true
      })
    },
    _filterDay(date) {
      // 선택한 날짜 기준으로 검색을 해온다. 21-9-2018
      if (date) {
        this.$store
          .dispatch(types.SET_REQUEST_USER_BOOKING, { date: date })
          .then(() => {
            // alert('Success edit')
            // console.log(this.searchForm)
          })
        const revertDate = date.split('-')
        const convertDate =
          revertDate[2] + '-' + revertDate[1] + '-' + revertDate[0]
        this.serviceLists.map(v => {
          if (v.hasOwnProperty('holidays')) {
            if (v.holidays.indexOf(convertDate) > 0) {
              v.filter = false
            } else {
              v.filter = true
            }
          } else {
            v.filter = true
          }
        })
      }
    },
    _filterName(e) {
      const name = e.target.value
      this.serviceLists.map(v => {
        if (v.name.search(name) < 0) {
          v.filter = false
        } else {
          v.filter = true
        }
      })
    },
    _filterSort(value) {
      console.log(value, this.serviceLists)
      switch (value) {
        case 'price_asc': {
          this.serviceLists.sort((a, b) => {
            if (Number(a.price) > Number(b.price)) {
              return 1
            }
            if (Number(a.price) < Number(b.price)) {
              return -1
            }
            return 0
          })
          break
        }
        case 'price_desc': {
          this.serviceLists.sort((a, b) => {
            if (Number(a.price) < Number(b.price)) {
              return 1
            }
            if (Number(a.price) > Number(b.price)) {
              return -1
            }
            return 0
          })
          break
        }
        case 'rating_asc': {
          this.serviceLists.sort((a, b) => {
            if (Number(a.rating) > Number(b.rating)) {
              return 1
            }
            if (Number(a.rating) < Number(b.rating)) {
              return -1
            }
            return 0
          })
          break
        }
        case 'rating_desc': {
          this.serviceLists.sort((a, b) => {
            if (Number(a.rating) < Number(b.rating)) {
              return 1
            }
            if (Number(a.rating) > Number(b.rating)) {
              return -1
            }
            return 0
          })
          break
        }
      }
    },
    _filterPriceRange(range) {
      console.log('__filterPriceRange:', range)
      this.serviceLists.map(v => {
        if (
          Number(range.start) <= Number(v.price) &&
          Number(v.price) <= Number(range.end)
        ) {
          v.filter = true
        } else {
          v.filter = false
        }
      })
    },
    _filterLanguage(lang) {
      console.log('__filterLanguage:', lang)
      if (lang.length > 0) {
        this.serviceLists.map(v => {
          console.log('v language:', v)
          if (v.languages) {
            const isItLang = lang.filter(
              l =>
                v.languages.filter(c => {
                  console.log(`${c} === ${l}`)
                  return c === l
                }).length > 0
            )
            console.log('isItLang:', isItLang + '==' + lang)
            if (isItLang.length === lang.length) {
              v.filter = true
            } else {
              v.filter = false
            }
          } else {
            v.filter = false
          }
        })
      } else {
        this.serviceLists.map(v => (v.filter = true))
      }
    },
    // 예약 시간 체크를 한다.
    _filterTime(time) {
      if (!this.searchDate) alert('Before select day')
      if (!time) return

      new Promise(resolve => {
        time.startTime *= 60
        time.endTime *= 60
        console.log('start Timesssss:', time)
        this.serviceLists.map(v => {
          // 주간 시간 설정이 되어 있는지 체크 한다.
          // console.log(` ${typeof v.times} !== 'undefined' &&
          //   ${this.searchDate}`)
          if (typeof v.times !== 'undefined' && this.searchDate) {
            const selectedDate = moment(this.searchDate, 'DD-MM-YYYY')
            const selectedDay = selectedDate.format('YYYY-MM-DD')
            const selectedDateWeek = new Date(selectedDay).getDay()
            // console.log('selected week:', selectedDateWeek, selectedDay)

            const week = v.times[selectedDateWeek]
            if (typeof week !== 'undefined') {
              for (let i in week) {
                console.log('week:', i)
                // console.log(` ${week[i].startTime} <= ${time.startTime} &&
                //   ${week[i].endTime} <= ${time.endTime}`)
                if (
                  week[i].startTime <= time.startTime &&
                  week[i].endTime <= time.endTime
                ) {
                  console.log('선택 타임이 포함이 안되기 때문에 가능함')
                  // 그럼 여기에서 예약이 가능한지 한번더 체크함
                  if (typeof v.reservation !== 'undefined') {
                    for (let day in v.reservation) {
                      // 선택한 날짜가 있어야지만, 체크 가능
                      if (day === selectedDay) {
                        for (let d = 0; d <= day.length; d++) {
                          if (
                            day[d].startTime <= time.startTime &&
                            day[d].endTime <= time.endTime
                          ) {
                            v.filter = false
                            console.log(
                              '예약인 경우 포함되어 있다면, 예약이 불가능'
                            )
                          } else {
                            console.log(
                              '선택 타임이 포함이 안되기 때문에 예약이 가능.'
                            )
                            v.filter = true
                          }
                        }
                      }
                    }
                  } else {
                    // 예약 프로퍼치가 없으면 무조건 true
                    v.filter = true
                  }
                } else {
                  // 포함이 안되기 때문에 모두 불가능
                  v.filter = false
                }
              }
            }
          } else {
            // 주간 가능시간 설정과, 날짜가 선정되지 않았기 때문에 모두 불가능으로 표시
            console.log(
              '주간 가능시간 설정과, 날짜가 선정되지 않았기 때문에 모두 불가능으로 표시'
            )
            v.filter = false
          }
        })

        resolve(this.serviceLists)
      }).then(result => {
        console.log('result', result.filter(v => v.filter === true))
      })
    },
    setSearchForm(model, value) {
      console.log(`model: ${model}, value:`, value)

      switch (model) {
        case 'searchCity': {
          this.searchCity = value === 'All' ? '' : value
          this.searchDate = null
          this.searchName = ''
          this.searchTime = ''
          break
        }

        case 'searchSpeciality': {
          this.searchSpeciality = value === 'All' ? '' : value
          this.searchDate = ''
          this.searchName = ''
          this.searchTime = ''
          break
        }
        default:
          this.searchDate = ''
          this.searchName = ''
          this.searchCity = ''
          this.searchSpeciality = ''
          this.searchTime = ''
          break
      }

      this.getServiceData()
    },
    detail(key) {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'request',
        active: true,
        type: 'full',
        propData: {
          serviceId: key
        }
      })
    },
    getServiceData() {
      const store = defaultStore.collection('photographers_service')
      let query = ''
      if (this.searchCity && this.searchSpeciality) {
        query = store
          .where('delete', '==', false)
          .where('city', '==', this.searchCity)
          .where('speciality', '==', this.searchSpeciality)
      } else if (this.searchCity) {
        query = store
          .where('delete', '==', false)
          .where('city', '==', this.searchCity)
      } else if (this.searchSpeciality) {
        query = store
          .where('delete', '==', false)
          .where('speciality', '==', this.searchSpeciality)
      } else {
        query = store.where('delete', '==', false)
      }

      query
        .get()
        .then(snap => {
          this.serviceLists = []
          snap.forEach(doc => {
            this.serviceLists.push(
              Object.assign(doc.data(), {
                id: doc.id,
                filterName: true,
                filterLanguage: true,
                filterPrice: true,
                filterDay: true,
                filterTime: true,
                filter: true
              })
            )
          })
        })
        .finally(() => {
          console.log(
            this.serviceLists
              .flatMap(e => e.price)
              .sort((a, b) => Number(a) - Number(b))
          )
          this.rangePriceStatic = this.serviceLists
            .flatMap(e => e.price)
            .sort((a, b) => Number(a) - Number(b))
          console.log('get data finish')
        })
    },
    getDefaultData() {
      Promise.all([
        getCities().then(res => {
          console.log('get city', res)
          this.city = res
        }),
        getSpecialties().then(res => {
          console.log('get speciality')
          this.speciality = res
        })
      ]).finally(() => {
        this.getServiceData()
        console.log('default load complete')
      })
    }
  },
  watch: {
    searchCity(value) {
      this.setSearchForm('searchCity', value)
    },
    searchSpeciality(value) {
      this.setSearchForm('searchSpeciality', value)
    },
    searchDate(value) {
      if (value) {
        this._filterDay(value)
        this.searchTime = ''
      }
    },
    searchTime(value, oldValue) {
      if (value !== oldValue && this.searchDate) {
        this._filterTime(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.service-lists {
  overflow-x: hidden;
  min-height: 600px;

  .search-box {
    /*border: 1px solid red;*/
    height: 80px;
    display: flex;

    .dropdown-box-type-1 {
      border-right: none;
    }

    .dropdown-calendar-type-1 {
      border-right: none;
    }
  }

  .search-box-1 {
    position: relative;
    margin: 25px 0 0 0;
    display: flex;
    width: 100%;
    height: 40px;
    /*border: 1px solid red;*/
    .space {
      margin: 0 12px 0 0;
    }

    .search {
      ::placeholder {
        color: #dbdbdb;
      }

      width: 240px;
      bottom: 18px;
      right: 1px;
      float: right;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      position: absolute;
      outline: none;
      height: 30px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.9px;
      text-align: left;
    }

    .language {
    }

    .search-reset {
      cursor: pointer;
      display: flex;
      align-items: center;
      background: none;
      width: 20px;
      height: 20px;
      font-size: 10px;
    }
  }

  .lists {
    width: 100%;
    z-index: 100;
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fill, 240px);
    justify-content: space-between;
    grid-row-gap: 68px;
    /*align-content: space-between;*/
    .item {
      /*border: 1px solid red;*/
      /*width: 22.5%;*/
      height: auto;
    }

    .loading {
      margin: auto;
      position: relative;
      /*border: 1px solid red;*/
      text-align: center;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
